<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>John R. Christensen is a Canadian author of six novels. In his professional life, he was an executive life strategist. He uses his knowledge of the intricacies of relationships and communication to illuminate his vivid characters and creative arc of his story lines. He lives with his wife, Hazel in Burlington, Ontario, Canada.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?31763ef8